import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_SCREEN,
   DELETE_SCREEN,
   GET_SCREEN,
   UPDATE_SCREEN,
   GET_ONE_SCREEN,
} from '../types';

export const getScreen = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item-screen/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SCREEN,
            payload: res.data.data,
         });
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
      // console.error('Failed to get itemgroup. Please try again. :', err);
   }
};

export const addScreen = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/item-screen/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_SCREEN, payload: res.data.data });
         setTimeout(() => {
            toast.success('screen added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
      return res;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateScreen = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/item-screen/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SCREEN, payload: res.data.data });

         setTimeout(() => {
            toast.success('screen updated successfully!');
         }, 1000);
      }

      return res;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

// Delete ItemGroup
export const deleteScreen = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/item-screen/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SCREEN, payload: { id } });
         toast.success('screen deleted successfully!');
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to delete item-group. Please try again.');
   }
};

export const getSingleScreen = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/item-screen/item/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_SCREEN, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
